import { Record } from 'immutable';
export const TranslatedLogEventMessageFieldDefinitionKeys = {
  FIELD_KEY: 'fieldKey',
  MESSAGE_RESOLVER: 'messageResolver',
  IS_PRIMARY_RISK_MESSAGE_FIELD: 'isPrimaryRiskMessageField',
  IS_SECONDARY_RISK_MESSAGE_FIELD: 'isSecondaryRiskMessageField'
};
export default class TranslatedLogEventMessageFieldDefinition extends Record({
  [TranslatedLogEventMessageFieldDefinitionKeys.FIELD_KEY]: undefined,
  [TranslatedLogEventMessageFieldDefinitionKeys.MESSAGE_RESOLVER]: undefined,
  [TranslatedLogEventMessageFieldDefinitionKeys.IS_PRIMARY_RISK_MESSAGE_FIELD]: undefined,
  [TranslatedLogEventMessageFieldDefinitionKeys.IS_SECONDARY_RISK_MESSAGE_FIELD]: undefined
}, 'TranslatedLogEventMessageFieldDefinition') {}